/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Vu Dinh Luan (vdluan@rsupport.com)
 *
 * @description
 *
 * @created at Fri Sep 13 2024
 **/

import styled from "@emotion/styled";
import { Column } from "@/frameworks/designStuff/components";
import CreateGroupSpaceBackground from "@/assets/background/default/img_create_group_space_background.png";

export const ViewerWrap = styled(Column)`
	width: 100vw;
	height: 100vh;
	position: relative;
	background-color: ${({ theme }) => theme.colors.neutral_00_94};
	overflow: hidden;
	backdrop-filter: blur(10px);
`;

export const NewGroupSpaceWrapper = styled(Column)`
	width: 100vw;
	height: 100vh;
	position: relative;
	background-color: ${({ theme }) => theme.colors.neutral_00_94};
	overflow: hidden;
	backdrop-filter: blur(10px);
	background-image: url(${CreateGroupSpaceBackground});
	background-size: cover;
	background-repeat: no-repeat;
	background-position: bottom;
`;

export const BackgroundContent = styled(Column)`
	background-color: ${({ theme }) => theme.colors.neutral_00_100};
	filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.12)) drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.04));
	width: 400px;
	min-height: 560px;
	border-radius: 40px;
	padding: 0 20px;
`;

export const ImagesContent = styled(Column)`
	margin-top: auto;
	width: 100%;
	height: 100%;
	flex-grow: 1;
	@media (max-width: 768px) {
		flex-direction: column;
	}
`;

export const Container = styled(Column)`
	display: flex;
	width: 100%;
	height: 100%;
	justify-content: center;
	align-items: center;
	@media (max-width: 768px) {
		flex-direction: column;
		padding: 20px;
	}
`;
